export default [
  {
    path: "/404",
    name: "Undefined",
    component: () => import("@/pages/error/404.vue"),
    meta: {
      title: "404",
    },
  },
  {
    path: "/403",
    name: "Authority",
    component: () => import("@/pages/error/403.vue"),
    meta: {
      title: "403",
    },
  },
];
